import { PhosphorTrain } from "components/Atoms/PhosphorIcon";
import React from "react";
import { getCityStateCountry } from "shared/utils/addressUtils";
import { TravelHeaderLayout } from "./TravelHeaderLayout";

interface TrainHeaderProps {
  train: server.dto.Train
  passengers: server.dto.ContactSmallV2[]
}

export const TrainHeader = ({ train, passengers }: TrainHeaderProps) =>
  <TravelHeaderLayout
    icon={<PhosphorTrain iconColor="white" iconSize="large" />}
    departure={{ name: train.departure.name, address: getCityStateCountry(train.departure.address) || undefined }}
    arrival={{ name: train.arrival.name, address: getCityStateCountry(train.arrival.address) || undefined }}
    dateTime={train.dateTime}
    detail={train.trainNumber}
    durationInMinutes={train.durationInMinutes}
    artist={train.artist}
    passengers={passengers.map(p => p.name.fullName)}
  />;
